// Criação de minicurso: nome, tema e comando (gerado do nome até a pessoa editar).
import React, { useState } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { addDoc, collection } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { FiX } from 'react-icons/fi';
import { firestore } from '../../config/firebaseConfig';
import {
  LIMITES, PADRAO_APROVACAO, PADRAO_INTERVALO, PADRAO_LEMBRETE,
  comandoDisponivel, gerarComando, normalizarComando, validarComando,
} from './util';

function NovoCursoModal({ tenantId, cursos, temas, onCriado, onFechar }) {
  const [nome, setNome] = useState('');
  const [tema, setTema] = useState('');
  const [comando, setComando] = useState('');
  const [comandoEditado, setComandoEditado] = useState(false);
  const [tentou, setTentou] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const alterarNome = (valor) => {
    setNome(valor);
    if (!comandoEditado) setComando(valor.trim() ? comandoDisponivel(gerarComando(valor), cursos) : '');
  };

  const erroNome = !nome.trim() ? 'Informe o nome do curso.' : '';
  const erroComando = validarComando(comando, cursos);
  const mostrarErro = (erro, sujo) => (tentou || sujo) && erro;

  const criar = async (e) => {
    e.preventDefault();
    setTentou(true);
    if (erroNome || erroComando) return;
    setSalvando(true);
    try {
      const ref = await addDoc(collection(firestore, 'minicursos'), {
        nome: nome.trim(),
        comando,
        tema,
        tenantId,
        status: 'inativo',
        createdAt: new Date(),
        intervaloEtapasEmMinutos: PADRAO_INTERVALO,
        percentualAprovacao: PADRAO_APROVACAO,
        lembreteAposHoras: PADRAO_LEMBRETE,
      });
      toast.success('Curso criado. Agora adicione as etapas.');
      onCriado(ref.id);
    } catch (erro) {
      console.error('Erro ao criar minicurso:', erro);
      toast.error('Não foi possível criar o curso.');
      setSalvando(false);
    }
  };

  const erroComandoVisivel = mostrarErro(erroComando, comandoEditado && comando);
  const erroNomeVisivel = mostrarErro(erroNome, false);

  return (
    <Modal isOpen onRequestClose={onFechar} className="mc-modal" overlayClassName="mc-overlay" contentLabel="Novo minicurso">
      <form onSubmit={criar} noValidate className="mc-form">
        <header className="mc-modal__topo">
          <h2 className="mc-modal__titulo">Novo minicurso</h2>
          <button type="button" className="btn-ghost mc-icone-botao" onClick={onFechar} aria-label="Fechar">
            <FiX aria-hidden="true" />
          </button>
        </header>

        <div className="mc-grade">
          <div className="mc-campo mc-campo--largo">
            <label htmlFor="mc-novo-nome">Nome do curso</label>
            <input
              id="mc-novo-nome"
              type="text"
              value={nome}
              maxLength={LIMITES.nome}
              onChange={(e) => alterarNome(e.target.value)}
              aria-invalid={Boolean(erroNomeVisivel)}
              aria-describedby={erroNomeVisivel ? 'mc-novo-nome-erro' : undefined}
              autoComplete="off"
              autoFocus
            />
            {erroNomeVisivel && <span id="mc-novo-nome-erro" className="mc-campo__erro">{erroNome}</span>}
          </div>

          <div className="mc-campo mc-campo--largo">
            <label htmlFor="mc-novo-comando">Comando no WhatsApp</label>
            <input
              id="mc-novo-comando"
              type="text"
              className="mc-mono"
              value={comando}
              placeholder="INICIAR_..."
              onChange={(e) => { setComandoEditado(true); setComando(normalizarComando(e.target.value)); }}
              aria-invalid={Boolean(erroComandoVisivel)}
              aria-describedby="mc-novo-comando-ajuda"
              autoComplete="off"
              spellCheck={false}
            />
            <span id="mc-novo-comando-ajuda" className={erroComandoVisivel ? 'mc-campo__erro' : 'mc-campo__ajuda'}>
              {erroComandoVisivel || 'O aluno envia este texto para começar. Gerado a partir do nome; pode editar.'}
            </span>
          </div>

          <div className="mc-campo mc-campo--largo">
            <label htmlFor="mc-novo-tema">Tema</label>
            <select id="mc-novo-tema" value={tema} onChange={(e) => setTema(e.target.value)} aria-describedby="mc-novo-tema-ajuda">
              <option value="">Sem tema</option>
              {temas.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
            <span id="mc-novo-tema-ajuda" className="mc-campo__ajuda">
              Usado para sugerir pílulas e questões ao montar as etapas. <Link to="/configuracao/temas">Gerenciar temas</Link>
            </span>
          </div>
        </div>

        <p className="mc-nota">
          O curso começa <strong>inativo</strong>: monte as etapas, confira a prévia e ative quando estiver pronto.
          Intervalo de 1 dia, aprovação com 70% e lembrete após 48 h (dá para mudar depois).
        </p>

        <footer className="mc-modal__rodape">
          <button type="button" className="btn-secondary mc-botao" onClick={onFechar}>Cancelar</button>
          <button type="submit" className="btn-primary mc-botao" disabled={salvando}>
            {salvando ? 'Criando...' : 'Criar curso'}
          </button>
        </footer>
      </form>
    </Modal>
  );
}

export default NovoCursoModal;
